//cookie操作
function getsec(str)
{
  if(str == undefined){
    return str
  }
  if(str == -1){
    return str
  }
  var str1=str.substring(1,str.length)*1;
  var str2=str.substring(0,1);
  if (str2=="s")
  {
    return str1*1000;
  }
  else if (str2=="h")
  {
    return str1*60*60*1000;
  }
  else if (str2=="d")
  {
    return str1*24*60*60*1000;
  }
}
export function getCookie(name)
{
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
export function delCookie(name)
  {
    /*  setCookie(name, null, -1);*/
    var strsec = getsec(-1);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec*1);
    document.cookie = name + "="+ escape (null) + ";expires=" + exp.toGMTString()+"; path=/";
  }
export function setCookie(name,value,time)
    {
      var strsec = getsec(time);
      var exp = new Date();
      exp.setTime(exp.getTime() + strsec*1);
      document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+"; path=/";
    }

export function statPushPost(params){
    var _this = this;
     if(process.env.NODE_ENV == 'development'){
        return false;
      }
    if(!params){
		params = {
		  "eventAction": "view",
		  "eventCategory": "view",
		  "optLabel": "",
		  "optValue": "",
		  "url":window.location.href,
		}
    }else if(!params.url){
		//params.url = window.location.href;
	}
    // _this.$api.statPush(params).then(res => {
    //   if (res.code == 200) {
    //     console.log('统计成功');
    //   } else {
    //     _this.$message.error(res.msg);
    //   }
    // }).catch(function(error) {
    //   _this.$message.error(error.msg);
    // });
  }

